module.exports = __webpack_public_path__ + "static/media/bg.bfd323f2.png";